import { IEirSalesAskAvailableAppointments } from "@modules/eirSalesFacade/interfaces/models/IEirSalesAskAvailableAppointments";
import { mapEirSalesAskAvailableAppointmentsResponse } from "@modules/eirSalesFacade/mappers/mapEirSalesAskAvailableAppointmentsResponse";
import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { askAvailableAppointmentsRoute } from "@api-routes/eirSalesFacade";

export const postAskAvailableAppointments = (prospectReference: string, offerId: number, options: IFetchOptions = {}) =>
    fetcher<IEirSalesAskAvailableAppointments>(askAvailableAppointmentsRoute(prospectReference, offerId), {
        method: "POST",
        mapper: mapEirSalesAskAvailableAppointmentsResponse,
        ...options,
    });
